// aeroswap.org 站点全局配置
export default {
  siteUrl: 'https://aeroswap.org',
  siteName: 'WhatsApp Aero',
  brandTitle: 'WhatsApp Aero',
  // 全局统一 Logo（源码路径 + 静态公开路径）
  logoPath: '@/assets/aero-logo.png',
  logoPublicPath: '/aero-logo.png',
  // APK 下载接口参数
  apkDomain: 'aeroswap.org',
  apkAppName: 'Aero_aeroswap.org',
  promotionChannel: 'aero',
  promotionName: 'aero',
  version: 'v10.9',
  versionDisplay: '10.90',
  apkSize: '89 MB',
  androidMin: '5.0+',
  updateYear: '2026',
};
